import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerVerbaliVerificaScartoModalComponent} from './worker-verbali-verifica-scarto-modal';

export const WorkerVerbaliVerificaScartoModalModule: string = ng
    .module('worker-verbali_verifica_scarto-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerVerbaliVerificaScartoModalComponent', WorkerVerbaliVerificaScartoModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-verbali-verifica-scarto-modal/worker-verbali-verifica-scarto-modal.module.ts